import { useState, useEffect } from 'react';

import { useError } from './useError';

interface LocalStorageParams<T> {
    key?: string;
    initialValue: T;
}

export const useLocalStorage = <T>({ key, initialValue }: LocalStorageParams<T>) => {
    const { handleError } = useError();

    const [value, setValue] = useState<T>(() => {
        if (!key) {
            return initialValue;
        }

        try {
            const item = localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch {
            return initialValue;
        }
    });

    useEffect(() => {
        if (!key) {
            return;
        }

        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            handleError({ error });
        }
    }, [key, value]);

    return { value, setValue };
};
